exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.printer-head, .printer-body {\r\n  display: flex;\r\n  margin-top: -1px;\r\n  border-color: #ccc;\r\n  margin-bottom: 0px;\r\n  border-style: solid;\r\n  border-width: 1px 0 0 1px;\r\n}\r\n.printer-head .col {\r\n  font-weight: bold;\r\n  padding: 10px 0.75rem;\r\n}\r\n.printer-head .col, .printer-body .col {\r\n  margin-left: 0;\r\n  border-color: #ccc;\r\n  border-style: solid;\r\n  border-width: 0px 1px 1px 0px;\r\n}*/\r\n.printer-body td {\r\n  white-space: nowrap;\r\n  padding: 5px 10px !important;\r\n}\r\n.printer-body .input-field {\r\n  margin-top: 0;\r\n}\r\n.printer-body .input-field input[type=\"text\"] {\r\n  height: 2rem;\r\n  margin-bottom: 15px;\r\n}\r\n.printer-body .input-field input[type=\"number\"] {\r\n  margin-bottom: 5px;\r\n}\r\n.erreo-test .error-msg {\r\n  margin-top: 0 !important;\r\n}\r\n.narration {\r\n  text-align: left;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-users/designer-commissions/designer-commissions.component.css
// module id = ../../../../../src/app/mnt-users/designer-commissions/designer-commissions.component.css
// module chunks = common